import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { UpdatePlan } from '@app-types/service.type';

type Response = {
    updated: boolean;
};

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

const editPlan = async (id: number, data: UpdatePlan): Promise<Response> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            `/api/admin/plans/${id}`
        );
        const response = await axios.put(endpoint, data, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error editing plan:', err);
        return { updated: false };
    }
};

export { editPlan };
